import { useEffect } from 'react';
import Navbar from './Navbar';
import SearchBar from './SearchBar';
import TrendingSearches from './TrendingSearches';
import SEO from './SEO';
import { GAUtils } from '../model/GAUtils';

const Home = () => {
    // Track page view on mount
    useEffect(() => {
        GAUtils.trackPageView('home', 'XTEA - Telegram Search Engine');
    }, []);

    return (
        <div className="app-container">
            <SEO />
            <Navbar />
            <main className="main-content">
                <SearchBar />
                <TrendingSearches />
            </main>
        </div>
    );
};

export default Home;
